/**
 * Shared strings for the journey list states (Manage tab, per-job Journeys
 * tab, job trigger selector modal, add-to-journey sidebar) — previously
 * duplicated (and, for `noResults`/`loadError`, slightly drifted) across
 * those files.
 *
 * `noResults` text: two of the three original copies (the selector modal and
 * the add-to-journey sidebar) read "Engin journey passa við leitina"; the
 * manage tab's copy alone read "Engin journeys passa við leitina" (plural).
 * The majority version wins here.
 *
 * `loadError` text: the selector modal (and the add-to-journey sidebar) read
 * only "Failed to load journeys" / "Ekki tókst að hlaða journeys", missing
 * the "Please try again" recovery clause the manage tab and per-job Journeys
 * tab already carried — this adopts the more complete version.
 */
export const journeyListStrings = {
  en: {
    loadError: 'Failed to load journeys. Please try again.',
    noResults: 'No journeys match your search',
    showingFirstResults: 'Showing the first {count} journeys — refine your search to see more',
    saveConfigError: 'Failed to save journey configuration',
    // fieldsCount has no real plural machinery in @locale/translate, so
    // callers branch explicitly on fieldsCount === 1 (the same explicit-branch
    // pattern add-fields-modal.tsx already uses for its own singular/plural
    // button text) rather than always rendering the plural "fields" form.
    // preFilledCount stays invariant in both languages: English "pre-filled"
    // does not inflect for number either way, so there is no plural bug to fix
    // there.
    fieldsSummaryOne: '{fieldsCount} field · {preFilledCount} pre-filled',
    fieldsSummaryMany: '{fieldsCount} fields · {preFilledCount} pre-filled',
  },
  is: {
    loadError: 'Ekki tókst að sækja Journey-ferli. Reyndu aftur.',
    noResults: 'Engin Journey-ferli fundust við leitina',
    showingFirstResults:
      'Fyrstu {count} Journey-ferlin eru sýnd. Þrengdu leitina til að finna fleiri.',
    saveConfigError: 'Ekki tókst að vista stillingar Journey-ferlisins',
    fieldsSummaryOne: 'Fjöldi reita: {fieldsCount} · Útfylltir fyrirfram: {preFilledCount}',
    fieldsSummaryMany: 'Fjöldi reita: {fieldsCount} · Útfylltir fyrirfram: {preFilledCount}',
  },
};
